document.addEventListener("DOMContentLoaded", function () {
  initUpsellScrollbars();
  initSlideruleGridDrag();

  const upsellObserver = new MutationObserver(() => {
    initUpsellScrollbars();
    initSlideruleGridDrag();
  });

  const body = document.body;
  if (body) {
    upsellObserver.observe(body, {
      childList: true,
      subtree: true
    });
  }
});

function initSlideruleGridDrag() {
  document.querySelectorAll('.sliderule-grid').forEach(function(grid) {
    if (grid.dataset.dragInitialized) return;
    grid.dataset.dragInitialized = 'true';

    var startX = 0;
    var startScrollLeft = 0;
    var isDragging = false;
    var activePointerId = null;
    var THRESHOLD = 5;
    var moveHistory = [];
    var rafId = null;

    function cancelAnim() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }

    function getVelocity() {
      var now = Date.now();
      var recent = moveHistory.filter(function(m) { return now - m.t < 80; });
      if (recent.length < 2) return 0;
      var first = recent[0], last = recent[recent.length - 1];
      var dt = last.t - first.t;
      return dt > 0 ? (first.x - last.x) / dt * 16 : 0;
    }

    function findSnapTarget() {
      var items = grid.querySelectorAll('.menu__block');
      var gridRect = grid.getBoundingClientRect();
      var best = null, bestDist = Infinity;
      items.forEach(function(item) {
        // left position of item relative to scrollable area
        var itemLeft = grid.scrollLeft + item.getBoundingClientRect().left - gridRect.left;
        var dist = Math.abs(grid.scrollLeft - itemLeft);
        if (dist < bestDist) { bestDist = dist; best = itemLeft; }
      });
      return best !== null ? best : grid.scrollLeft;
    }

    function smoothScrollTo(target) {
      var from = grid.scrollLeft;
      var dist = target - from;
      if (Math.abs(dist) < 1) { grid.style.scrollSnapType = ''; return; }
      var duration = Math.max(150, Math.min(350, Math.abs(dist) * 1.2));
      var startTime = null;

      function ease(t) { return t < 0.5 ? 2*t*t : -1 + (4 - 2*t)*t; }

      function step(ts) {
        if (!startTime) startTime = ts;
        var p = Math.min((ts - startTime) / duration, 1);
        grid.scrollLeft = from + dist * ease(p);
        if (p < 1) {
          rafId = requestAnimationFrame(step);
        } else {
          rafId = null;
          grid.style.scrollSnapType = '';
        }
      }
      rafId = requestAnimationFrame(step);
    }

    function releaseWithMomentum(vel) {
      vel = Math.max(-50, Math.min(50, vel));
      var FRICTION = 0.88;

      function step() {
        vel *= FRICTION;
        grid.scrollLeft += vel;
        if (Math.abs(vel) > 1) {
          rafId = requestAnimationFrame(step);
        } else {
          rafId = null;
          smoothScrollTo(findSnapTarget());
        }
      }

      if (Math.abs(vel) > 1) {
        rafId = requestAnimationFrame(step);
      } else {
        smoothScrollTo(findSnapTarget());
      }
    }

    grid.addEventListener('dragstart', function(e) { e.preventDefault(); });

    grid.addEventListener('pointerdown', function(e) {
      cancelAnim();
      if (activePointerId !== null) return;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startScrollLeft = grid.scrollLeft;
      isDragging = false;
      moveHistory = [];
      grid.style.scrollSnapType = 'none';
      grid.setPointerCapture(e.pointerId);
    });

    grid.addEventListener('pointermove', function(e) {
      if (e.pointerId !== activePointerId) return;
      var delta = startX - e.clientX;
      if (!isDragging && Math.abs(delta) > THRESHOLD) isDragging = true;
      if (isDragging) {
        moveHistory.push({ x: e.clientX, t: Date.now() });
        if (moveHistory.length > 12) moveHistory.shift();
        grid.scrollLeft = startScrollLeft + delta;
      }
    });

    function onEnd(e) {
      if (e.pointerId !== activePointerId) return;
      activePointerId = null;
      if (isDragging) {
        releaseWithMomentum(getVelocity());
        grid.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
        }, { capture: true, once: true });
      } else {
        grid.style.scrollSnapType = '';
      }
      isDragging = false;
    }

    grid.addEventListener('pointerup', onEnd);
    grid.addEventListener('pointercancel', onEnd);
  });
}

document.addEventListener('shopify:section:load', initSlideruleGridDrag);

function initUpsellScrollbars() {
  const upsellGrids = document.querySelectorAll('.upsell-list-grid[data-scrollbar]');
  
  upsellGrids.forEach((scrollbar) => {
    // Verificar si ya está inicializado
    if (scrollbar.hasAttribute('data-scrollbar-initialized')) {
      return;
    }

    const arrowNext = scrollbar.parentNode.querySelector('[data-scrollbar-arrow-next]');
    const arrowPrev = scrollbar.parentNode.querySelector('[data-scrollbar-arrow-prev]');

    if (!arrowNext || !arrowPrev) {
      return;
    }

    // Función para mostrar/ocultar flechas según la posición del scroll
    function toggleArrows() {
      const scrollLeft = scrollbar.scrollLeft;
      const scrollWidth = scrollbar.scrollWidth;
      const clientWidth = scrollbar.clientWidth;
      const isAtStart = scrollLeft <= 0;
      const isAtEnd = Math.round(scrollLeft + clientWidth + 1) >= scrollWidth;

      // Usar setTimeout para evitar parpadeos
      setTimeout(() => {
        arrowPrev.classList.toggle('is-hidden', isAtStart);
        arrowNext.classList.toggle('is-hidden', isAtEnd);
      }, 200);
    }

    // Función para desplazar hacia adelante
    function goToNext() {
      const moveWith = scrollbar.getBoundingClientRect().width / 2;
      const position = moveWith + scrollbar.scrollLeft;
      
      scrollbar.scrollTo({
        top: 0,
        left: position,
        behavior: 'smooth'
      });

      arrowPrev.classList.remove('is-hidden');
      toggleArrows();
    }

    // Función para desplazar hacia atrás
    function goToPrev() {
      const moveWith = scrollbar.getBoundingClientRect().width / 2;
      const position = scrollbar.scrollLeft - moveWith;
      
      scrollbar.scrollTo({
        top: 0,
        left: position,
        behavior: 'smooth'
      });

      arrowNext.classList.remove('is-hidden');
      toggleArrows();
    }

    // Event listeners
    arrowNext.addEventListener('click', (event) => {
      event.preventDefault();
      goToNext();
    });

    arrowPrev.addEventListener('click', (event) => {
      event.preventDefault();
      goToPrev();
    });

    scrollbar.addEventListener('scroll', toggleArrows);

    // Inicializar estado de las flechas
    toggleArrows();

    // Revisar cuando cambia el tamaño de la ventana
    window.addEventListener('resize', () => {
      setTimeout(toggleArrows, 200);
    });

    // Marcar como inicializado
    scrollbar.setAttribute('data-scrollbar-initialized', 'true');
  });
}

document.addEventListener('shopify:section:load', initUpsellScrollbars);
document.addEventListener('shopify:section:reorder', initUpsellScrollbars);